// extracted by mini-css-extract-plugin
export default {"container":"service_container__8Z5x8","title":"service_title__-Eh0g"};